import { atom } from "recoil";

const pointsScreenState = atom<boolean>({
  key: "pointsScreenState",
  default: false,
});

export default pointsScreenState;
